import { Input } from 'antd';
import TagInput from '@/components/TagInput/TagInput';
import SelectForm from './SelectForm';
import { getMessage } from './util';

const { TextArea } = Input,
    InputForm = (props) => {
        let { setting = {}, updated, desc, en_name, field_type } = props;
        const disabled = updated !== 0;
        if (setting.type === 'textarea') {
            return (
                <TextArea
                    className={'grt-dynamic-text-area'}
                    style={{ resize: 'none' }}
                    disabled={disabled}
                    placeholder={desc || getMessage(field_type)}
                    allowClear
                    rows={4}
                ></TextArea>
            );
        }
        if (setting.type === 'tag') {
            return <TagInput disabled={disabled} en_name={en_name} {...setting} placeholder={desc || getMessage(field_type)}></TagInput>;
        }
        if (en_name === 'org_id') {
            return SelectForm(props);
        }
        return <Input className={'grt-dynamic-input'} disabled={disabled} placeholder={desc || getMessage(field_type)} allowClear></Input>;
    };
export default InputForm;
